import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[redExceljsParameterContainer]',
  standalone: true,
})
export class ExceljsParameterContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
